import React from "react";
import styled from "@emotion/styled";
import { COPYRIGHT_COPY } from "../../utils/constants";

const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  padding: 0 16px;

  position: absolute;
  bottom: 24px;
  z-index: 1;

  @media screen and (max-width: 560px) {
    bottom: 16px;
  }
`;

const FooterLinks = styled.div`
  max-width: 480px;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  grid-gap: 8px 16px;
`;

const FooterLink = styled.a`
  color: #868482;
  font-size: 14px;
  text-decoration: none;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 384px) {
    font-size: 12px;
  }

  @media (max-height: 720px) {
    font-size: 13px;
  }

  @media (max-height: 680px) {
    font-size: 12px;
  }
`;

const FooterText = styled.a`
  color: #868482;
  font-size: 14px;
  margin-top: 16px;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media screen and (max-width: 560px) {
    font-size: 10px;

    text-align: center;
  }
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <FooterLinks>
        <FooterLink href="https://berserkermail.com/pp" target="_blank">
          Privacy Policy
        </FooterLink>
        <FooterLink href="https://berserkermail.com/tos" target="_blank">
          Terms of Service
        </FooterLink>
        <FooterLink
          href="https://berserkermail.com/subscription_agreement"
          target="_blank"
        >
          Subscription Agreement
        </FooterLink>
        <FooterLink
          href="https://berserkermail.com/guidelines.html"
          target="_blank"
        >
          BerserkerMail Guidelines
        </FooterLink>
        <FooterLink
          href="https://berserkermail.com/cancellation.html"
          target="_blank"
        >
          Refunds & Cancellations Policy
        </FooterLink>
        <FooterLink href="https://berserkermail.com/contact" target="_blank">
          Contact Us
        </FooterLink>
      </FooterLinks>

      <FooterText dangerouslySetInnerHTML={{ __html: COPYRIGHT_COPY }} />
    </FooterWrapper>
  );
}
